import styles from '@/components/book/Glyph.module.css';
import { KnowellName } from '@/components/book/KnowellName';

/** Fixed meanings (DESIGN-SPEC §1.11). ◐ ‖ ◇ here mean Revisit reasons, not campaign states. */
export const GLYPHS = {
  star: '★',
  starOff: '☆',
  new: '†',
  overview: '¶',
  /** Drawn as knowell's k mark; the text stands in where only a string will do. */
  k: 'knowell',
  quizDue: '◐',
  focusLapsed: '‖',
  highlightsIdle: '◇',
  current: '✓',
  open: '−',
  closed: '+',
  more: '⋯',
} as const;

export type GlyphName = keyof typeof GLYPHS;

interface GlyphProps {
  name: GlyphName;
  /** Reads the meaning to assistive tech; without it the glyph is decorative. */
  label?: string;
  /** A fixed-width slot so glyphs of different widths share one axis in a column. */
  slot?: boolean;
  className?: string;
}

export function Glyph({ name, label, slot = false, className }: GlyphProps) {
  return (
    <span
      className={[styles.glyph, slot ? styles.slot : '', className ?? ''].filter(Boolean).join(' ')}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    >
      {name === 'k' ? <KnowellName variant="mark" /> : GLYPHS[name]}
    </span>
  );
}
